import KunLoading23 from './src/index'

KunLoading23.install = function (Vue) {
	Vue.component(KunLoading23.name, KunLoading23);
}

export default KunLoading23;
